import { render, staticRenderFns } from "./LuRole.vue?vue&type=template&id=7b1f0259"
import script from "./LuRole.vue?vue&type=script&lang=js"
export * from "./LuRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports